import {AxiosError} from 'axios';
import {POST_ATTACH_FILE_SC} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PresignedUrlResponse} from '../../models/PresignedUrl';
import {ApplicationType, UploadDocumentType} from '../../api/candidate/config/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostUploadPresignedUrlRequest {
  uuid: string;
  applicationType: ApplicationType;
  filenames: string[];
  uploadDocumentType?: UploadDocumentType;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PresignedUrlResponse[]) => void;
  onError?: (err: AxiosError<GenericErrorResponse>) => void;
}

export const usePostUploadPresignedUrl = ({onSuccess, onError}: Input) => {
  const postUploadPresignedUrl = async (payload: PostUploadPresignedUrlRequest) => {
    const res = await axiosClient.post<PresignedUrlResponse[]>(POST_ATTACH_FILE_SC, {
      uuid: payload.uuid,
      applicationType: payload.applicationType,
      filenames: payload.filenames,
      uploadDocumentType: payload.uploadDocumentType,
    });
    return res.data;
  };

  return useCustomMutation(postUploadPresignedUrl, {
    onSuccess,
    onError,
  });
};
